module.exports = __webpack_public_path__ + "static/media/icon_installation.1c461216.svg";